import { useEffect } from 'react';

import { useSettingsStore } from '@/store/useSettingsStore';

export const SettingsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { language, direction } = useSettingsStore((s) => s.settings);

  /* Apply global HTML attributes */
  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = direction;
  }, [language, direction]);

  return <>{children}</>;
};
